export default __webpack_public_path__ + "static/media/loader.672b28bc.gif";